module.exports = __webpack_public_path__ + "static/media/FiraCode-Light.16cfbc94.ttf";